module.exports = __webpack_public_path__ + "cf847e7bbbffb017c159ff75cf6c63af.png";